import { Injectable } from '@angular/core';

import { JwtHelperService } from '@auth0/angular-jwt';

import { LogService } from '@ridango/core';

import { Capacitor } from '@capacitor/core';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';

import { saveAs } from 'file-saver';

import { NotificationFacade } from '../../notifications';
import { PurchaseFacade } from '../../purchase';
import { ReceiptService } from '../receipt.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ReceiptFacade {
    constructor(
        private service: ReceiptService,
        private notifications: NotificationFacade,
        private purchaseFacade: PurchaseFacade,
        private ls: LogService,
        private translate: TranslateService
    ) {}

    getPdf(lang: string, token: string = null) {
        this.notifications.removeAll();
        this.purchaseFacade.setInvoiceLoading(true);

        return this.service.getPdfSpa(lang, token).subscribe(
            async (data: Blob) => {
                const jwtHelper = new JwtHelperService();
                const decodedResult = jwtHelper.decodeToken(token);
                if (Capacitor.isNativePlatform()) {
                    const encodedData = await this.blobToBase64(data, 'application/pdf');
                    const result = await Filesystem.writeFile({
                        path: `${decodedResult.shopping_cart_id}.pdf`,
                        data: encodedData,
                        directory: Directory.Data
                    });

                    await FileOpener.open({
                        filePath: result.uri,
                        contentType: 'application/pdf'
                    });
                } else {
                    saveAs(data, `${decodedResult.shopping_cart_id}.pdf`);
                }
                this.purchaseFacade.setInvoiceLoading(false);
            },
            (err) => {
                this.ls.log(this, 'getPdf', err);
                this.notifications.error(this.translate.instant('LOCAL_GETTING_PDF_FAILED'));
                window.scroll(0, 0);
                this.purchaseFacade.setInvoiceLoading(false);
            }
        );
    }

    private async blobToBase64(blob: Blob, mimeType: string): Promise<string> {
        return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const dataUrlPrefix = `data:${mimeType};base64,`;
                const base64WithDataUrlPrefix = reader.result.toString();
                const base64 = base64WithDataUrlPrefix.replace(dataUrlPrefix, '');
                resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    sendToEmail(lang: string, email: string, token: string = null) {
        this.notifications.removeAll();

        return this.service.sendToEmail(lang, email, token).subscribe(
            (d) => {
                this.ls.log(this, 'sendInvoiceToEmail', d);
                this.notifications.success(this.translate.instant('LOCAL_RECIEPT_SENT_TO_EMAIL_SUCCESS'));
                window.scroll(0, 0);
            },
            (err) => {
                this.ls.log(this, 'sendInvoiceToEmail', err);
                this.notifications.error(this.translate.instant('LOCAL_RECIEPT_SENT_TO_EMAIL_ERROR'));
                window.scroll(0, 0);
            }
        );
    }
}
